import { createSelector } from 'reselect';

const customerSelector = state => state.template;
const createTemplateSelector = createSelector(customerSelector, template => template);

export default createTemplateSelector;
